import React from "react";
import styled from "styled-components";
import { Container } from "./layoutComponents";

import FaqItem from "./faqItem";

const FAQS = [
  {
    title: "What games will Tabletop Streamer support?",
    content: () => (
      <>
        Tabletop Streamer will initially support Warhammer 40,000. Because the
        software imports Battlescribe rosters, there is potential to add support
        for other games such as Age of Sigmar. <br /> <br /> If there is enough
        demand for other, non-GW games, and those games have list building apps
        that generate machine-parsable files (XML, JSON, etc.), then support may
        be considered.
      </>
    ),
  },
  {
    title: "Okay, but how does it work?",
    content: () => (
      <>
        Tabletop Streamer is a simple yet powerful suite of tools for adding
        broadcast-quality 3D graphics to tabletop games such as Warhammer
        40,000. <br /> <br />
        It works by capturing a video feed of a tabletop wargame, then provides
        intuitive tools to add annotations, unit markers, score boards, and
        auto-generated highlight clips on top of the video feed. <br /> <br />
        Typically, these graphics will be added to an overhead (top down) view
        of the board, but Tabletop Streamer’s 3D camera calibration tools allow
        for off-axis and three-quarter camera angles as well.
        <br /> <br /> Tabletop Streamer also has a mobile AR client app that
        makes for a great second or third camera. The app gives you the ability
        to have a handheld, moving camera to get the best angles of the battle
        while still rendering the same 3D graphics as the desktop server. <br />
        <br />
        The mobile app will support iOS and Android, and will be released
        shortly after the desktop app.
      </>
    ),
  },
  {
    title: "Sounds fancy. What are the hardware requirements?",
    content: () => (
      <>
        In general: a mid- to high-tier gaming PC. <br /> <br /> Basic hardware
        requirements are a Mac or PC with an external camera input (either a USB
        webcam, or an internal or external capture card) and a stable internet
        connection. <br /> <br /> Resolution, frame rate, and number of video
        inputs will be determined by your individual computer hardware specs.
        <br /> <br />
        To support multiple 4K@60Hz video sources, you will need an RTX 30
        series GPU and minimum 16GB RAM.
      </>
    ),
  },
  {
    title: "When will Tabletop Streamer be available?",
    content: () => (
      <>
        We’re a small, two-person team building this tool in our spare time.
        Despite that, a working alpha version is already being tested, and a
        closed beta will be announced shortly.
      </>
    ),
  },
  {
    title: "Who is behind this wonderful piece of software?",
    content: () => (
      <>
        Just an AR app developer and new 40k player who believe battle reports
        could be even more engaging and easier to follow... if only some simple
        graphics tools existed... 🤔
      </>
    ),
  },
  {
    title: "I'm sold, but how much will it cost?",
    content: () => (
      <>
        Exact pricing is still being determined, but we expect to adopt a "good,
        better, best" subscription pricing model. The base version will have all
        the necessary features, but higher tiers will allow deeper brand
        customization, support more camera inputs, etc.
        <br /> <br /> The mobile app will always be free, as it requires the
        desktop app to work.
      </>
    ),
  },
];

const Faq = () => (
  <WrapperContent id="faq">
    <StyledContainer>
      <h1 style={{ marginBottom: 40 }}>FAQ</h1>
      <div>
        {FAQS.map(({ title, content }) => (
          <FaqItem title={title} key={title}>
            {content()}
          </FaqItem>
        ))}
      </div>
    </StyledContainer>
  </WrapperContent>
);

const WrapperContent = styled.div`
  margin-top: 100px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--primary-font);
  font-family: poppins;
  text-align: center;

  button {
    padding: 12px 0;
    font-size: 24px;
    color: var(--primary-font);

    @media (max-width: 768px) {
      font-size: 20px;
    }
    @media (max-width: 470px) {
      font-size: 18px;
    }
  }
`;

const StyledContainer = styled(Container)`
  max-width: 1000px;
`;

export default Faq;
